import adminApiFetch from './apiService';

export const webhookService = {
  // List all webhooks
  getList: async () => {
    const response = await adminApiFetch('webhooks');
    return response.json();
  },

  // Get paginated records with filters
  getRecords: async (params) => {
    const response = await adminApiFetch('webhooks/get_records', {
      method: 'POST',
      body: JSON.stringify(params),
    });
    return response.json();
  },

  // Get single webhook detail
  get: async (id) => {
    const response = await adminApiFetch(`webhooks/${id}`);
    return response.json();
  },

  // Create new webhook
  create: async (data) => {
    const response = await adminApiFetch('webhooks', {
      method: 'POST',
      body: JSON.stringify({ webhook: data }),
    });
    return response.json();
  },

  // Update webhook
  update: async (id, data) => {
    const response = await adminApiFetch(`webhooks/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ webhook: data }),
    });
    return response.json();
  },

  // Delete webhook
  delete: async (id) => {
    const response = await adminApiFetch(`webhooks/${id}`, {
      method: 'DELETE',
    });
    return response.json();
  },

  // Toggle active status
  toggleActive: async (id) => {
    const response = await adminApiFetch(`webhooks/${id}/toggle_active`, {
      method: 'POST',
    });
    return response.json();
  },

  // Regenerate secret key
  regenerateSecret: async (id) => {
    const response = await adminApiFetch(`webhooks/${id}/regenerate_secret`, {
      method: 'POST',
    });
    return response.json();
  },

  // Send test webhook
  test: async (id) => {
    const response = await adminApiFetch(`webhooks/${id}/test`, {
      method: 'POST',
    });
    return response.json();
  },

  // Get available events
  getAvailableEvents: async () => {
    const response = await adminApiFetch('webhooks/available_events');
    return response.json();
  },
};
